import { servicesUrlConfig } from "shared/config/setting";

/**
 * Robot Connections API Service
 * Centralized API calls for robot peer connection info (conn-manager)
 */
export const robotPeerConnectionsService = {
  /**
   * Get robot connection info by robot ID
   * @param {function} authFetch - Authenticated fetch function
   * @param {string} robotPeerId - Robot Peer ID
   * @returns {Promise} API response with robot connection details (status, settings, etc.)
   */
  async getPeerInfoByPeerId(authFetch, robotPeerId) {
    const url = `${servicesUrlConfig.ROBOTS_CONNECTIONS_API.get_by_id}/${robotPeerId}`;
    return await authFetch(url);
  },

  async getRobotClientsByRobotId(authFetch, robotId) {
    const url = `${servicesUrlConfig.ROBOTS_CONNECTIONS_API.get_by_robot_id}/${robotId}`;
    return await authFetch(url);
  },

  async getRobotPeerStatus(authFetch, robotPeerId) {
    return await robotPeerConnectionsService.getPeerInfoByPeerId(authFetch, robotPeerId)
      .then(async (response) => {
        if (response && response.data) {
          const robotPeerInfo = response.data;          
          console.log(`Robot peer info for robot_id=${robotPeerId}:`, robotPeerInfo);
          if (robotPeerInfo && robotPeerInfo?.status) {
            return robotPeerInfo.status;
          }else {
            throw new Error(
              `Robot peer info for robot_id=${robotPeerId} does not contain status field.`
            );
          }
        } else {
          throw new Error(
            `Cannot fetch robot peer connection info for robot_id=${robotPeerId}: response was not ok.`
          );
        }
      });
  }

};